
import React from "react";
import { Calendar as CalendarComponent } from "@/components/ui/calendar";
import { Event } from "@/types";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface CalendarViewProps {
  selectedDate: Date | undefined;
  onSelectDate: (date: Date | undefined) => void;
  parsedEvents: Array<Event & { parsedStartDate: Date; parsedEndDate: Date }>;
}

const CalendarView = ({ 
  selectedDate, 
  onSelectDate, 
  parsedEvents 
}: CalendarViewProps) => {
  // Function to highlight dates with events
  const getDayClass = (date: Date): string => {
    // Normalize the date to start of day for comparison
    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);
    
    const hasEvent = parsedEvents.some(event => {
      const eventStart = new Date(event.parsedStartDate);
      eventStart.setHours(0, 0, 0, 0);
      
      const eventEnd = new Date(event.parsedEndDate);
      eventEnd.setHours(23, 59, 59, 999);
      
      return normalizedDate >= eventStart && normalizedDate <= eventEnd;
    });
    
    return hasEvent ? "bg-eco-100 text-eco-800 font-medium rounded-full" : "";
  };

  console.log("CalendarView rendering with", parsedEvents.length, "events");

  return (
    <div className="rounded-md border p-4 bg-white">
      <CalendarComponent
        mode="single"
        selected={selectedDate}
        onSelect={onSelectDate}
        className="rounded-md"
        showOutsideDays={true}
        classNames={{
          day_selected: "bg-eco-500 text-white hover:bg-eco-600 hover:text-white focus:bg-eco-500 focus:text-white",
          cell: "h-9 w-9 text-center text-sm p-0 relative focus-within:relative focus-within:z-20",
          day: "h-9 w-9 p-0 font-normal aria-selected:opacity-100",
          head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        }}
        components={{
          IconLeft: () => <ChevronLeft className="h-4 w-4" />,
          IconRight: () => <ChevronRight className="h-4 w-4" />,
        }}
        modifiers={{
          hasEvent: (date) => {
            if (!date) return false;
            
            // Normalize the date for comparison
            const normalizedDate = new Date(date);
            normalizedDate.setHours(0, 0, 0, 0);
            
            return parsedEvents.some(event => {
              const eventStart = new Date(event.parsedStartDate);
              eventStart.setHours(0, 0, 0, 0);
              
              const eventEnd = new Date(event.parsedEndDate);
              eventEnd.setHours(23, 59, 59, 999);
              
              return normalizedDate >= eventStart && normalizedDate <= eventEnd;
            });
          }
        }}
        modifiersClassNames={{
          hasEvent: "bg-eco-100 text-eco-800 font-medium rounded-full"
        }}
      />
    </div>
  );
};

export default CalendarView;
